export default {
    cruzados: [],
    ofrecerTipoSelect: [
        {
            text: 'Productos',
            value: 'productos'
        },
        {
            text: 'Categorias',
            value: 'categorias'
        }
    ],
    condicionesTipoSelect: [
        {
            text: 'Si carrito no tiene',
            value: 'notiene'
        }
    ],
    prioridad: [
        {
            text: 'Alta',
            value: '1'
        },
        {
            text: 'Media',
            value: '2'
        },
        {
            text: 'Baja',
            value: '3'
        },
    ]
}